import ToolCard from "./card";

import Modal from "../../common/modals";
import { useAppDispatch, useAppSelector } from "../../../hooks/store-hooks";
import { openModal } from "../../../store/slices/modalSlice";
import RentReceipt from "./rent-receipt";
import { useNavigate } from "react-router-dom";
import { trackEvent } from "../../../analytics";

const CalculatorsAndTools = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { modalName, isModalOpen } = useAppSelector((state) => state.modal);

  const toolsData = [
    {
      id: 1,
      title: "Calculate HRA",
      image: "/assets/money/tax/hra1.webp",
      onClick: () => {
        navigate("/money/protect/tax/hra");
        trackEvent("tax_cta_clicked", { cta_for: "hra_calculator" });
      },
    },
    {
      id: 2,
      title: "Generate Rent Receipt",
      image: "/assets/money/sidebar-icon/stock.webp",
      onClick: () => {
        dispatch(
          openModal({
            modalName: "Generate Rent Receipt",
            isModalOpen: true,
            modalData: {
              title: "Generate Rent Receipt",
              id: 1,
            },
          }),
        );
        trackEvent("tax_cta_clicked", { cta_for: "generate_rent_receipt" });
      },
    },
    {
      id: 3,
      title: "Old vs New Tax Regime",
      image: "/assets/money/tax/tax-regime.webp",
      comingSoon: true,
    },
  ];

  return (
    <div className="w-full bg-white p-6 rounded-[12px]">
      <div className="flex items-center mb-6">
        <h2 className="text-2xl font-bold text-gray-900">
          Calculators and Tools
        </h2>
        <img
          src="/assets/money/investmentOptions.png"
          alt="investment options"
          className="ml-2 w-fit h-[11.5px] object-cover"
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {toolsData.map((tool, index) => (
          <>
            <ToolCard
              key={index}
              title={tool.title}
              image={tool.image}
              comingSoon={tool.comingSoon}
              onClick={tool.onClick}
            />
          </>
        ))}
      </div>
      {isModalOpen && modalName === "Generate Rent Receipt" ? (
        <Modal
          isOpen={isModalOpen && modalName === "Generate Rent Receipt"}
          blurBg={false}
          size="large"
          customClass="my-[6%] md:w-[980px]"
        >
          <div className="w-full">
            <RentReceipt />
          </div>
        </Modal>
      ) : null}
    </div>
  );
};

export default CalculatorsAndTools;
